import _toConsumableArray from "/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
export default function codepointLength(source) {
  // get codepoints length instead of UTF16 code units with the string Iterator.
  return source && _toConsumableArray(source).length || 0;
}